import { render, staticRenderFns } from "./faultDetailService.vue?vue&type=template&id=064c7ec6&scoped=true&"
import script from "./faultDetailService.vue?vue&type=script&lang=js&"
export * from "./faultDetailService.vue?vue&type=script&lang=js&"
import style0 from "./faultDetailService.vue?vue&type=style&index=0&id=064c7ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c7ec6",
  null
  
)

export default component.exports